var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-school-class-component"},[(_vm.schoolListInfo.length)?_c('div',{staticClass:"md-school-con"},[_c('img',{attrs:{"src":require("@/assets/img/school.png"),"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }